import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Notification\SendNotificationToUsers::__invoke
* @see app/Http/Controllers/Notification/SendNotificationToUsers.php
* @route '/api/notification/notify-users'
*/
const SendNotificationToUsers = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendNotificationToUsers.url(options),
    method: 'post',
})

SendNotificationToUsers.definition = {
    methods: ["post"],
    url: '/api/notification/notify-users',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Notification\SendNotificationToUsers::__invoke
* @see app/Http/Controllers/Notification/SendNotificationToUsers.php
* @route '/api/notification/notify-users'
*/
SendNotificationToUsers.url = (options?: RouteQueryOptions) => {
    return SendNotificationToUsers.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Notification\SendNotificationToUsers::__invoke
* @see app/Http/Controllers/Notification/SendNotificationToUsers.php
* @route '/api/notification/notify-users'
*/
SendNotificationToUsers.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendNotificationToUsers.url(options),
    method: 'post',
})

export default SendNotificationToUsers